import {
    Button,
    CardContent,
    Grid,
    TextField,
    Typography,
    Divider,
    Autocomplete,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Navigate, useNavigate } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";


type Props = {};

const DocTypeAdd = (props: Props) => {
    const[toaster,setToaster]=useState(false);

    let navigate = useNavigate();

    const { t } = useTranslation();
    const requiredFields = ['DocType'];
    const [DocTypeOption, setDocTypeOption] = useState([{ value: "-1", label:t("text.SelectDocType") }]);

    useEffect(() => {
        const dataString = localStorage.getItem("userdata");
        getDocType();
    }, []);


    const getDocType = () => {
        const collectData = {
            "docID": -1,
            "parentDocId": 0,
            "userId": ""
        };
        axios
          .post(HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`, collectData)
          .then((res) => {
            const arr:any = [];
            console.log("result" + JSON.stringify(res.data.data));
            for (let index = 0; index < res.data.data.length; index++) {
              arr.push({
                label: res.data.data[index]["doc_Name"],
                value: res.data.data[index]["docID"]
              });
            }
            setDocTypeOption(arr);
          });
      };

    const validationSchema = Yup.object({
        parentDocId: Yup.string().test(
            'required',

            function (value: any) {
                return value && value.trim() !== '';
            }
        ),
    });

    const formik = useFormik({
        initialValues: {
            docID: -1,
            doc_Name: "",
            doc_shortname: "",
            session_year: "",
            entry_Date: "",
            inst_ID: 0,
            parentDocId: 0,
            parentLevel: 0,
            userId: "",
            parentDoc_Name: "",
            srn: 0
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {

            const response = await axios.post(
                HOST_URL.HOST_URL2 + `OtherDocType/AddUpdateOtherDocType`,
                values
            );
            try {
                setToaster(false);
                toast.success(response.data.mesg);
                navigate('/DocManagement/DocType');
            } catch (error) {
                setToaster(true);
                toast.error(response.data.mesg);
            }
        },
    });

    const back = useNavigate();

    return (
        <div>
            <div
                style={{
                    padding: "-5px 5px",
                    backgroundColor: "#ffffff",
                    borderRadius: "5px",
                    marginTop: "3vh",
                    // border: ".5px solid #FF7722",
                }}
            >
                <CardContent>
                    <Typography
                        variant="h5"
                        textAlign="center"
                        style={{ fontSize: "18px", fontWeight: 500 }}
                    >
                        {t("text.CreateDocType")}
                    </Typography>

                    <Grid item sm={4} xs={12}>
                        <Typography style={{ marginTop: "-75px" }}>
                            <Button
                                type="submit"
                                onClick={() => back(-1)}
                                variant="contained"
                                style={{
                                    marginBottom: 15,
                                    marginTop: "45px",
                                    backgroundColor:`var(--header-background)`,
                                    width: 20,
                                }}
                            >
                                <ArrowBackSharpIcon />
                            </Button>
                        </Typography>
                    </Grid>
                    <Divider />
                    <br />
                    <form onSubmit={formik.handleSubmit}>
                    {toaster===false ?"":<ToastApp/>}
                        <Grid item xs={12} container spacing={2}>
                        <Grid item xs={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={DocTypeOption}
                         value={
                          DocTypeOption.find(
                      (option) => parseInt( option.value) === formik.values.parentDocId
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue) => {
                    console.log(newValue?.value);
                    
                    formik.setFieldValue("parentDocId", newValue?.value);
                    formik.setFieldValue("parentDoc_Name", newValue?.label);
                    formik.setFieldTouched("parentDocId", true); 
                    formik.setFieldTouched("parentDocId", false); 
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={
                      <span>
                        {t("text.SelectDocType")} {""}
                        {requiredFields.includes('parentDoc_Name') && (
                          <span style={{ color: formik.values.parentDoc_Name ? 'green' : 'red' }}>*</span>
                        )}
                      </span>
                    } />
                  )}
                />

                {formik.touched.parentDoc_Name && formik.errors.parentDoc_Name ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.parentDoc_Name}
                  </div>
                ) : null}
                                        </Grid>
                            <Grid md={4} item>
                                <TextField
                                    label={
                                        <span>
                                           {t("text.EnterDocName")} {requiredFields.includes('DocType') && (
                                                <span style={{ color: formik.values.doc_Name ? 'green' : 'red' }}>*</span>
                                            )}
                                        </span>
                                    }
                                    value={formik.values.doc_Name}
                                    placeholder={t("text.EnterDocName")}
                                    size="small"
                                    fullWidth
                                    name="doc_Name"
                                    id="doc_Name"
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                {formik.touched.doc_Name && formik.errors.doc_Name ? (
                                    <div style={{ color: "red", margin: "5px" }}>{formik.errors.doc_Name}</div>
                                ) : null}
                            </Grid>

                            <Grid md={4} item>
                                <TextField
                                    label={t("text.EnterShortName")}
                                    value={formik.values.doc_shortname}
                                    placeholder={t("text.EnterShortName")}
                                    size="small"
                                    fullWidth
                                    name="doc_shortname"
                                    id="doc_shortname"
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>
                            <Grid md={4} item>
                                <TextField
                                type="date"
                                    label={t("text.EntryDate")}
                                    value={formik.values.entry_Date}
                                    InputLabelProps={{ shrink: true }}
                                    name="entry_Date"
                                    id="entry_Date"
                                    placeholder={t("text.EntryDate")}
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>

                          


                            <Grid item xs={12} spacing={2} style={{ display: 'flex', justifyContent: 'center' }}>
                                <Grid xs={6} style={{ margin: '6px' }}>
                                    <Button
                                        type="submit"
                                        fullWidth
                                        style={{
                                            backgroundColor:`var(--header-background)`,
                                            color: "white",
                                            marginTop: "10px",
                                        }}

                                    >
                                        {t("text.save")}
                                    </Button>
                                </Grid>

                                <Grid xs={6} style={{ margin: '6px' }}>
                                    <Button
                                        type="reset"
                                        fullWidth
                                        style={{
                                            backgroundColor: "#F43F5E",
                                            color: "white",
                                            marginTop: "10px",
                                        }}
                                        onClick={(e) => formik.resetForm()}
                                    >
                                        {t("text.reset")}
                                    </Button>
                                </Grid>

                            </Grid>
                        </Grid>
                        {/* </Card> */}
                    </form>
                </CardContent>
            </div>
        </div>
    );
};

export default DocTypeAdd;
